const profile = {
  name: "Fabien Lapert",
  title: "Développeur Web Full-Stack",
  subtitle: "Diplômé Master ECV Digital",
  age: new Date().getFullYear() - 1999,
  location: "Rouen, France",
  email: "fabien.lapert@example.com",
  phone: "+33 X XX XX XX XX",

  bio: {
    short:
      "Développeur Full-Stack spécialisé en JavaScript et technologies modernes, passionné par l'innovation digitale.",
    long: `Diplômé d'un Master à l'ECV Digital de Lille, je suis un développeur web full-stack spécialisé en JavaScript et ses écosystèmes, désormais prêt à relever de nouveaux défis professionnels. Ma passion pour la création d'applications modernes et performantes m'a amené à me concentrer particulièrement sur React, TypeScript, et Node.js.

Mon parcours académique et professionnel m'a permis d'acquérir une solide expérience en développement front-end avec React, Vue.js et les dernières technologies JavaScript, ainsi qu'en développement back-end avec Node.js et les frameworks modernes.

Autodidacte et curieux, j'aime explorer de nouvelles technologies JavaScript et relever des défis techniques complexes. Mes expériences en alternance m'ont appris l'importance du travail en équipe et de la méthodologie agile dans le développement de solutions innovantes.

Disponible dès octobre 2025, je recherche activement une opportunité pour mettre mes compétences au service d'une équipe dynamique et contribuer à des projets ambitieux.

En dehors de la programmation, je suis passionné par le sport, la cuisine et la musique, activités qui nourrissent ma créativité et mon équilibre personnel.`,
  },

  interests: [
    "🏃‍♂️ Sport & Fitness",
    "🍳 Cuisine",
    "🎵 Musique & Piano",
    "📚 Veille technologique",
    "🎮 Gaming",
    "✈️ Voyages",
  ],

  languages: [
    { name: "Français", level: "Natif" },
    { name: "Anglais", level: "Intermédiaire" },
    { name: "Espagnol", level: "Intermédiaire" },
  ],

  social: {
    github: "https://github.com/fabienlpt",
    linkedin: "https://www.linkedin.com/in/fabienlpt/",
    email: "mailto:lapertfabien@gmail.com",
  },

  availability: {
    status: "Disponible pour de nouvelles opportunités",
    type: "CDI Développeur Web Full-Stack",
    startDate: "Septembre 2025",
  },
};

export default profile;
